<template>
	<div class="autocomplete-filter" style="width: 100%;">
		<v-autocomplete
			class="search"	
			ref="autocomplete-ref"
			data-qa="autocomplete-text-field"
      density="compact"
			v-model="select"
			text
			:label="$props.label"
			v-model:search="search"
      :loading="loading"
      :items="items"
			item-title="alias"
			item-value="id"
			:clear-on-select="true"
      hide-no-data
			:solo="solo"
			:placeholder="placeholder"
			clearable
			:rules="rules"
			:required="required"
			:disabled="disabled"
			clear-icon="ecc:ecc-M-Chiudi"
			append-icon=""
			@keyup.enter="emitConfirm"
			@update:modelValue="setValue"
      ></v-autocomplete>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'AutocompleteFilter',
	data () {
    return {
			loading: false,
      items: [],
      search: null,
      select: null,
      filterTimeout: undefined,
      lastValidBackspaceTime: undefined,
			wrapperObject: undefined
    }
	},
	props: {
		elements: {
			type: Array,
			default: () => [],
		},
		autoCompletePreSelect: {
      type: String,
      default: "",
    },
		placeholder: {
			type: String
		},
		label: {
			type: String
		},
		rules: {
			type: Array,
			default: () => [],
		},
		required: {
			type: Boolean,
			default: true
		},
		solo: {
			type: Boolean,
			default: false,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		hideNoData: {
			type: Boolean,
			default: false
		},
		type: {
			type: String
    },
		disabled: {
			type: Boolean,
			default: () => false
		},
		resetOnSelect: {
			type: Boolean,
			default: () => true
		},
		maxWidth: {
			type: String,
			default: '300px'
		},
		clearOnCloseDrawer: {
      type: Boolean,
      default: false,
    },
	},
	watch: {
    search (val) {
      this.querySelections(val)
    },
		clearOnCloseDrawer(val) {
			if (val) this.select = null;
		},
		autoCompletePreSelect (val) {
			this.select = val
		},
  },
  methods: {
    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.elements.filter(e => {
          return (e.alias || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    },
		emitConfirm(event) {
      this.$emit('confirm', event.target.value);
		},
		setValue(event) {
			if (event != null) {
				this.$emit('setValue', event);
				if (this.resetOnSelect) {
					this.$nextTick(() => {
						setTimeout(() => {
							this.select = null
							this.$refs["autocomplete-ref"].reset()
						}, 100) 
					}) 
				}
			} else {
				this.$emit('cleared', event);
			}
		},
  },
	async mounted() {
    this.select = this.autoCompletePreSelect;
  }
});
</script>

<style>
.autocomplete-filter .v-field { font-size: 16px;}
.autocomplete-filter .ecc:ecc-M-Chiudi { font-size: 14px;}
</style>
